import React, { useState } from "react";
import "./college_project.css";
import "bootstrap/dist/css/bootstrap.min.css";

const CollegeProjects = (props) => {
  const [selectedProject, setSelectedProject] = useState("");

  const selectedProjectData =
    props.projects && props.projects.find((project) => project.name === selectedProject);

  return (
    <div className="college_project">
      <div className="college_project_layout">
        <div className="college_meta">
          <div className="prof_name">{props.prof_name}</div>
          <div className="duration">{props.duration}</div>
        </div>

        <div className="college_details">
          <div className="project-pills">
            {props.projects.map((project) => (
              <button
                key={project.id || project.name}
                type="button"
                className={`project-pill ${
                  selectedProject === project.name ? "project-pill-selected" : ""
                }`}
                onClick={() =>
                  setSelectedProject((current) =>
                    current === project.name ? "" : project.name
                  )
                }
              >
                {project.name}
              </button>
            ))}
          </div>

          {selectedProjectData && (
            <div className="project-detail">
              {selectedProjectData.description}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CollegeProjects;
